import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, MapPin, Phone, Mail } from "lucide-react";
import { SITE } from "@/data/site";
import { api } from "@/lib/api";

export default function Footer() {
  const [jobsActive, setJobsActive] = useState(true);

  useEffect(() => {
    api.get("/settings/jobs").then((r) => setJobsActive(r.data.active)).catch(() => {});
  }, []);

  return (
    <footer className="bg-charred text-cream/80">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-20 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <img
            src="/logo-sapore.png"
            alt="SAPORÉ — Gastronomia d'asporto"
            className="w-[170px] lg:w-[190px] h-auto"
            style={{ opacity: 1, filter: "none", mixBlendMode: "normal", objectFit: "contain" }}
            data-testid="footer-logo"
          />
          <p className="mt-2 font-serif italic text-lg text-terracotta-light">{SITE.tagline}</p>
          <div className="mt-6 flex gap-3">
            <a href={SITE.social.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" aria-label="Facebook"
              className="w-10 h-10 rounded-full border border-cream/20 grid place-items-center hover:bg-terracotta hover:border-terracotta transition-colors">
              <Facebook size={17} />
            </a>
            <a href={SITE.social.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram"
              className="w-10 h-10 rounded-full border border-cream/20 grid place-items-center hover:bg-terracotta hover:border-terracotta transition-colors">
              <Instagram size={17} />
            </a>
          </div>
          <p className="mt-6 text-sm text-cream/60">Segui SAPORÉ per scoprire i piatti del giorno, le nuove preparazioni e tutte le novità della nostra gastronomia.</p>
        </div>

        <div className="text-sm space-y-3">
          <p className="text-xs uppercase tracking-[0.25em] text-terracotta-light mb-4">Contatti</p>
          <p className="flex items-start gap-2"><MapPin size={15} className="mt-0.5 shrink-0" /> {SITE.address}</p>
          <a href={SITE.phoneHref} className="flex items-center gap-2 hover:text-cream transition-colors"><Phone size={15} /> {SITE.phoneDisplay}</a>
          <a href={`mailto:${SITE.email}`} data-testid="footer-email-link" className="flex items-center gap-2 hover:text-cream transition-colors"><Mail size={15} /> {SITE.email}</a>
          <p className="pt-3 text-cream/50">{SITE.titolare}<br />{SITE.piva}</p>
        </div>

        <div className="text-sm space-y-3">
          <p className="text-xs uppercase tracking-[0.25em] text-terracotta-light mb-4">Informazioni</p>
          <Link to="/privacy" data-testid="footer-privacy-link" className="block hover:text-cream transition-colors">Privacy Policy</Link>
          <Link to="/cookie" data-testid="footer-cookie-link" className="block hover:text-cream transition-colors">Cookie Policy</Link>
          <button
            onClick={() => window.dispatchEvent(new Event("sapore:cookie-prefs"))}
            data-testid="footer-cookie-preferences"
            className="block hover:text-cream transition-colors"
          >
            Gestisci preferenze cookie
          </button>
          <Link to="/allergeni" data-testid="footer-allergeni-link" className="block hover:text-cream transition-colors">Informazioni sugli allergeni</Link>
          {jobsActive && (
            <Link to="/lavora-con-noi" data-testid="footer-lavora-link" className="block hover:text-cream transition-colors">Lavora con noi</Link>
          )}
        </div>
      </div>
      <div className="border-t border-cream/10">
        <p className="max-w-[1400px] mx-auto px-6 md:px-12 py-5 text-xs text-cream/50">© 2026 SAPORÉ. Tutti i diritti riservati.</p>
      </div>
    </footer>
  );
}
